import axios from 'axios';

const BASE = '/api/v1.0/content';

const ContentServices = {
  strings(): Promise<any> {
    const URL = `${BASE}/strings`;
    return axios.get(URL, {});
  },
};

export default ContentServices;
